import React, { cloneElement } from 'react';
import SidebarItem from '../../components/SidebarItem';
import ResourceDataMap from '../../components/ResourceDataMap';
import { linksDossier } from 'routes/navigation/sidebarDossierLinks';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import '../sidebar/style.css';
import { useParams } from 'react-router-dom';
import { useGetDossierByIdQuery } from 'actions/dossiers/queries';
import { 
  PARTAGE_DOSSIER, 
  PRODUCTS_PATH, 
  SOLDES, 
  CLIENT, 
  VENTE, 
  FACTURATION, 
  CREANCES 
} from 'routes/navigation/navigationPaths';

const COMMERCIAL_ALLOWED_PATHS = new Set([
  PRODUCTS_PATH,
  SOLDES,
  FACTURATION,
  CLIENT,
  VENTE,
  CREANCES,
]);

const SidebarWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

const SidebarDossierComponent = ({
  activeLinkColor,
  activeLinkBgColor,
  colorOnHover,
  linkColor,
  openedMenu,
}) => {
  const { clientID: dossier_id } = useParams();
  const { data: dossier } = useGetDossierByIdQuery({ id: dossier_id }, { skip: !dossier_id });
  const userRole = dossier?.user_role;

  const filteredLinks = linksDossier.filter(link => {
    if (userRole === 'COMMERCIAL') {
      return COMMERCIAL_ALLOWED_PATHS.has(link.path);
    }
    if (link.path === PARTAGE_DOSSIER) {
      return userRole === 'ADMIN';
    }
    return true;
  });

  const ClonedSidebarItem = ({ linkItem }) =>
    cloneElement(<SidebarItem linkItem={linkItem} openedMenu={openedMenu} inDossier={false} />, {
      activeLinkColor,
      activeLinkBgColor,
      colorOnHover,
      linkColor,
    });

  return (
    <div className={`sidebar-shell hideScrollbar ${openedMenu ? 'is-collapsed' : ''}`}>
      <SidebarWrapper className="sidebar-nav-scroll">
        <ResourceDataMap
          resourceData={filteredLinks}
          resourceItem={ClonedSidebarItem}
          resourceName="linkItem"
        />
      </SidebarWrapper>
    </div>
  );
};

SidebarDossierComponent.propTypes = {
  bgColor: PropTypes.string,
  activeLinkColor: PropTypes.string.isRequired,
  activeLinkBgColor: PropTypes.string.isRequired,
  colorOnHover: PropTypes.string.isRequired,
  linkColor: PropTypes.string.isRequired,
  openedMenu: PropTypes.bool.isRequired,
};

export default SidebarDossierComponent;
